import step1 from './01.svg'
import step2 from './02.svg'
import step3 from './03.svg'
import step4 from './04.svg'
import step5 from './05.svg'
import step6 from './06.svg'

const steps = [
  {
    trans: 'swee:tutorial.step1',
    img: step1,
  },{
    trans: 'swee:tutorial.step2',
    img: step2
  },{
    trans: 'swee:tutorial.step3',
    img: step3,
  },{
    trans: 'swee:tutorial.step4',
    img: step4
  },{
    trans: 'swee:tutorial.step5',
    img: step5
  },{
    trans: 'swee:tutorial.step6',
    img: step6,
  },
];

export default steps;


// WEBPACK FOOTER //
// ./src/apps/swee/tutorial/index.js